enum MissingEInvoices {
  Many,
  Single,
  None,
}

export default MissingEInvoices